module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../~/_babel-runtime@6.26.0@babel-runtime/core-js/promise.js
// module id = 949
// module chunks = 0